import { RootState } from "../Store";

export const SELECT_PROFILE_ROLE = (state: RootState) =>
  state.profileSlice.type;

export const SELECT_PROFILE_DATA = (state: RootState) => state.profileSlice;
